<template>
  <el-dialog v-bind="$attrs" align-center center :close-on-click-modal="false" destroy-on-close draggable width="auto">
    <slot></slot>
  </el-dialog>
</template>

<script setup >
import { onMounted, ref} from 'vue'
</script>
<style lang="scss">

</style>